const Config = {
  SUPPORT_EMAIL: "suporte@linkdobem.com",
  URL_SITE_PADRAO: "https://tv.linkdobem.com/",
  URL_SITE_1: "https://go.linkdobem.com/",
  URL_AFILIADO: "https://dash.linkdobem.com/",
  URL_DASH: "https://dash.linkdobem.com/",
  NUMBER_WHATSAPP: "+55119917769547",
};

export default Config;
